<!--Honers:荣誉奖项 2021/03/29 14:07:00 Sunanguang-->

<template>
  <div class="its-honers">
    <ts-page-layout center>
      <p class="its-honers-title">荣誉奖项</p>
      <p class="its-honer-list" v-html="honerStr"></p>
      <el-carousel :interval="4000" height="320px" indicator-position="none" arrow="always" :autoplay="false" @change="pauseVideo">
        <el-carousel-item>
          <div class="its-carousel-item" v-for="honer in videos" :key="'video-' + honer.id">
            <play-view ref="playViewRef" :vId="'play' + honer.id" :item="honer.video"></play-view>
            <p class="its-carousel-title">{{honer.title}}</p>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="its-carousel-item" v-for="honer in images" :key="'image-' + honer.id">
            <img class="its-image-honers" :src="getSrc(honer.id)">
            <p class="its-carousel-title">{{honer.title}}</p>
          </div>
        </el-carousel-item>
      </el-carousel>
    </ts-page-layout>
  </div>
</template>
<script>
import PlayView from '../../../components/PlayView'
export default {
  name: 'Honers',
  components: {
    PlayView
  },
  data() {
    return {
      honerStr: `
                2021年&nbsp;&nbsp;第80届中国（成都）教育装备展示会，学科网产品总监毛太辉接受新华社记者采访，“从学科网的角度来看，可以通过优质的数字教学资源，以及“教育新基建”背景下的智慧教学平台，从教学管理、评价、研训（等方面）提供优质的服务，极大地去提升老师的教学效率，降低使用成本。<br>
                2020年&nbsp;&nbsp;第78届中国（重庆）教育装备展示会，学科网创始人陈学艺博士接受央视采访：“我们通过云计算、云存储技术，将课中内容实时存储到云服务器上，通过大数据分析统计，为学校输出课堂报告，帮助教师实现精准教学。”<br>
                2020年&nbsp;&nbsp;荣获第七届国际智慧教育展览会中国校园好方案卓越案例奖<br>
                2019年&nbsp;&nbsp;荣获中国互联网教育评选盛典优质内容产品奖项<br>
                2018年&nbsp;&nbsp;荣获中国认证联盟教育行业优秀企业奖称号`,
      videos: [
        {
          id: 4,
          type: 'video',
          title: '新华社 | 第80届教装展学科网接受采访',
          video: {
            url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-14.mp4',
            playCover: require('@/assets/images/home/home-video4-cover.png'),
            coverType: 'honer'
          }
        },
        {
          id: 1,
          type: 'video',
          title: '学科网创始人陈学艺博士央视采访',
          video: {
            url: 'https://oss-ts-prod.oss-cn-hangzhou.aliyuncs.com/lecture/public/ued-video/ued-12.mp4',
            playCover: require('@/assets/images/home/honer_video_cover.png'),
            coverType: 'honer'
          }
        },
      ],
      images: [
        {
          id: 2,
          type: 'image',
          title: '中国教育技术协会会员单位'
        },
        {
          id: 3,
          type: 'image',
          title: '中国校园好方案卓越案例奖'
        }
      ]
    }
  },
  methods: {
    getSrc: function (id) {
      return require('@/assets/images/home/honer_' + id + '.png')
    },
    pauseVideo: function () {
      let videos = document.querySelectorAll('video')
      videos.forEach(element => {
        element.pause()
      });
    }
  }
}
</script>

<style scoped>
.its-honers {
  padding: 91px;
  width: 100%;
  height: 981px;
  background-color: white;
  padding-top: 60px;
  background: url(../../../../assets/images/home/honer_bg.jpg) no-repeat !important;
  background-size: 100%;
}

.its-honers-title {
  font-size: 36px;
  color: #333333;
  text-align: center;
}

.its-honer-list {
  font-size: 20px;
  line-height: 2.2;
  margin-bottom: 80px;
}

.its-carousel-title {
  text-align: center;
  font-size: 16px;
  margin-top: 15px;
}

.its-carousel-item >>> .ts-ali-player .ts-cover-btn,
.its-carousel-item >>> .prism-player .prism-big-play-btn {
  width: 42px !important;
  height: 42px !important;
  left: 50% !important;
  top: 50% !important;
  margin-left: -21px !important;
  margin-top: -21px !important;
  background: url(../../../../assets/images/home/play.png) no-repeat !important;
  background-size: cover !important;
}

.its-honers >>> .ts-play-cover,
.its-honers >>> .prism-player,
.its-honers >>> video {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.its-honers >>> .prism-player .prism-big-play-btn .outter {
  display: none;
}

.its-honers >>> .el-carousel__mask {
  background-color: transparent;
}

.its-honers >>> .el-carousel__arrow--left {
  width: 56px;
  height: 56px;
  background: url(../../../../assets/images/home/arraw_left.png) no-repeat !important;
  background-color: transparent;
}

.its-honers >>> .el-carousel__arrow--right {
  width: 56px;
  height: 56px;
  background: url(../../../../assets/images/home/arraw_right.png) no-repeat !important;
  background-color: transparent;
}

.its-honers >>> .el-carousel__arrow--right i,
.its-honers >>> .el-carousel__arrow--left i {
  display: none;
}

.its-carousel-item {
  height: 100%;
  width: calc(50% - 15px);
  float: left;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.30);
  border-radius: 8px;
}

.its-carousel-item:first-child {
  margin-right: 30px;
}

.its-image-honers {
  height: calc(100% - 50px);
  width: 100%;
  object-fit: fill;
}

.its-honers >>> .el-carousel__item {
   width: 100%;
   padding: 10px 120px;
}
</style>